export default {
  name: "CategoryCard",

  props: {
    item: { type: Object, required: true },
  },

  computed: {
    categorySlug() {
      return this.$route.params.category;
    },
    desktopSrc() {
      return this.item?.imageDesktop || null;
    },
    mobileSrc() {
      return this.item?.imageMobile || null;
    },

    cardTo() {
      return {
        name: "before-after-catalog",
        params: { lang: this.$route.params.lang },
        query: {
          category: this.categorySlug,
          case: this.item.slug,
        },
      };
    },
  },

  methods: {
    goToCatalog(e) {
      const interactive = e?.target?.closest?.("a, button, [role='button'], input, select, textarea");
      if (interactive) return;

      this.$router.push(this.cardTo);
    },
  },
};
